interface BudgetRange {
  id: string;
  label: string;
  range: string;
}

interface BudgetSelectorProps {
  selectedBudget: string;
  onSelect: (budgetId: string) => void;
}

const BudgetSelector = ({ selectedBudget, onSelect }: BudgetSelectorProps) => {
  const budgetRanges: BudgetRange[] = [
    { id: 'mini', label: 'Budget accessible', range: '1 000 € - 5 000 €' },
    { id: 'small', label: 'Petit budget', range: '5 000 € - 15 000 €' },
    { id: 'medium', label: 'Budget moyen', range: '15 000 € - 40 000 €' },
    { id: 'large', label: 'Grand budget', range: '40 000 € - 100 000 €' },
    { id: 'luxe', label: 'Budget premium', range: '> 100 000 €' },
  ];

  return (
    <div data-component-id="src/app/contact-quote/components/BudgetSelector.tsx:22:4" data-component-path="src/app/contact-quote/components/BudgetSelector.tsx" data-component-line="22" data-component-end-line="38" data-component-file="BudgetSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20gap-4%22%7D" className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {budgetRanges.map((budget) => (
        <button data-component-id="src/app/contact-quote/components/BudgetSelector.tsx:24:8" data-component-path="src/app/contact-quote/components/BudgetSelector.tsx" data-component-line="24" data-component-end-line="36" data-component-file="BudgetSelector.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%7D"
          key={budget.id}
          type="button"
          onClick={() => onSelect(budget.id)}
          className={`p-6 rounded-lg border-2 transition-all duration-300 text-center ${
            selectedBudget === budget.id
              ? 'border-primary bg-light-accent shadow-gold'
              : 'border-border bg-card hover:border-primary-light hover:shadow-subtle'
          }`}
        >
          <h3 data-component-id="src/app/contact-quote/components/BudgetSelector.tsx:34:10" data-component-path="src/app/contact-quote/components/BudgetSelector.tsx" data-component-line="34" data-component-end-line="34" data-component-file="BudgetSelector.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-playfair%20font-bold%20text-lg%20text-text-primary%20mb-2%22%7D" className="font-playfair font-bold text-lg text-text-primary mb-2">{budget.label}</h3>
          <p data-component-id="src/app/contact-quote/components/BudgetSelector.tsx:35:10" data-component-path="src/app/contact-quote/components/BudgetSelector.tsx" data-component-line="35" data-component-end-line="35" data-component-file="BudgetSelector.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%22%7D" className="text-sm text-text-secondary">{budget.range}</p>
        </button>
      ))}
    </div>
  );
};

export default BudgetSelector;